import { render, staticRenderFns } from "./IndexSelect.vue?vue&type=template&id=349d8576"
import script from "./IndexSelect.vue?vue&type=script&lang=js"
export * from "./IndexSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports